module.exports = __webpack_public_path__ + "bd149df1dfda2da9986f3ae2cd7f4a99.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-15.png
// module id = 1969
// module chunks = 0